import { Component } from '@angular/core';
import {HttpClient} from '@angular/common/http';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'argon-dashboard-angular';
  constructor(private http: HttpClient){}
  ngOnInit() {
    this.http.get<any>('https://api2.ecell.in/vsm/isact/').subscribe(data => {
      console.log(data)
      if(data=='true'){
        console.log("data")
      }
      else{
        console.log("not data")
        alert('Competition is closed now')
        window.location.href = 'https://ecell.in/vsm-fyers/';
      }
    })
  }
}
